import packageJson from '@/../package.json'

const IS_DEVELOPMENT = !!process.env.NEXT_PUBLIC_IS_DEVELOPMENT

export const configs = {
  BACK_URL:
    process.env.NEXT_PUBLIC_BACK_URL || 'https://api.portaldaemissora.com.br',
  BACK_SOCKET:
    process.env.NEXT_PUBLIC_BACK_SOCKET || 'wss://api.portaldaemissora.com.br',
  FRONT_URL:
    process.env.NEXT_PUBLIC_FRONT_URL || 'https://app.portaldaemissora.com.br',
  LANDING_PAGE_URL:
    process.env.NEXT_PUBLIC_LANDING_PAGE_URL_URL ||
    `https://portaldaemissora.com.br`,
  DOCUMENTATION_URL:
    process.env.NEXT_PUBLIC_DOCUMENTATION_URL ||
    `https://portaldaemissora.com.br/doc`,

  SIGN_BACK_URL:
    process.env.NEXT_PUBLIC_SIGN_BACK_URL || 'https://api.ledgersign.com.br',
  SIGN_FRONT_URL:
    process.env.NEXT_PUBLIC_SIGN_FRONT_URL ??
    (IS_DEVELOPMENT
      ? 'http://localhost:8080'
      : 'https://app.ledgersign.com.br'),
  BASE_PATH: process.env.NEXT_PUBLIC_BASE_PATH, // "/portal-emissora"
  IS_DEVELOPMENT,
  IS_HOMOLOG: !!process.env.NEXT_PUBLIC_IS_HOMOLOG,

  SENTRY_DNS:
    'https://4fcb8039dc06163aaf6b887327c9f739@o4505756591194112.ingest.sentry.io/4505756605808640',
  HEAP_ANALYTICS_ID: process.env.NEXT_PUBLIC_HEAP_ANALYTICS_ID || '3787855242',

  VERSION: packageJson.version,

  REQUEST_TIMEOUT: process.env.NEXT_PUBLIC_REQUEST_TIMEOUT || 5 * 60 * 1000,
  CAPTCHA_SITE_KEY: process.env.NEXT_PUBLIC_CAPTCHA_SITE_KEY,
  CAPTCHA_SECRET_KEY: process.env.NEXT_PUBLIC_CAPTCHA_SECRET_KEY,

  ENABLED_105_VERSION:
    process.env.NEXT_PUBLIC_ENABLED_105_VERSION === undefined
      ? true
      : Boolean(process.env.NEXT_PUBLIC_ENABLED_105_VERSION),
  ENABLED_106_VERSION:
    process.env.NEXT_PUBLIC_ENABLED_106_VERSION === undefined
      ? false
      : Boolean(process.env.NEXT_PUBLIC_ENABLED_106_VERSION),
  WHATSAPP_NUMBER: process.env.NEXT_PUBLIC_WHATSAPP_NUMBER ?? '5511974692125',

  FLAG_ACADEMIC_DOCUMENTATION_COURT_DECISION_DISABLED_IN_PRODUCTION: Boolean(
    process.env
      .NEXT_PUBLIC_FLAG_ACADEMIC_DOCUMENTATION_COURT_DECISION_DISABLED_IN_PRODUCTION !==
      'false',
  ),

  FLAG_OPEN_REGISTER_DISABLED_IN_PRODUCTION: Boolean(
    process.env.NEXT_PUBLIC_FLAG_OPEN_REGISTER_DISABLED_IN_PRODUCTION !==
      'false',
  ),

  RENOTARIZATION_WINDOW_IN_DAYS:
    Number(process.env.NEXT_PUBLIC_RENOTARIZATION_WINDOW_IN_DAYS) || 90,
}
